import React from "react";
import MoneyIncome from "../../assets/components/money-income";

// import MoneyIncome from "../../../../assets/components/money-income";
// import ExchangeInput from "../../../../components/base/exchange-input";

interface StatProps {
  icon: React.ReactNode;
  title: string;
  count: string;
  bgColor: string;
  titleTextColor?: string;
  countTextColor?: string;
  bgIcon?: string;
}

const StatItem: React.FC<StatProps> = ({
  icon,
  title,
  count,
  bgColor,
  titleTextColor,
  countTextColor,
  bgIcon,
}) => {
  return (
    <div
      className={`flex items-center gap-4 px-5 py-8 ${bgColor} rounded-xl p-4 w-full`}
    >
      <div className={`p-4 mt-1 mr-3 bg-white  ${bgIcon} rounded-full`}>
        <span className="w-32 text"> {icon}</span>
      </div>

      <div className="flex flex-col gap-6 text-white    ">
        <p className={`text-sm leading-[19.12px]  ${titleTextColor}`}>{title}</p>
        <p className={`text-2xl font-bold leading-[32.78px] ${countTextColor}`}>
          {count}
        </p>
      </div>
    </div>
  );
};

const OverviewStats: React.FC = () => {
  return (
    <div className="flex justify-between gap-4 items-center rounded-xl border border-[#F1F2F4] p-6">
      <div className="w-full">
        <p className="text-[#111827] text-xl leading-[30px] font-semibold">Statistics</p>
        <p className="text-[#111827] text-sm leading-[21px] font-light">Overview of your transactions</p>


        
      </div>

      <StatItem
        icon={<MoneyIncome />}
        title="Total Payout"
        count="15"
        bgColor="bg-[#0040C2]"
        bgIcon="bg-[#3276CC]"
      />
      <StatItem
        icon={<MoneyIncome />}
        title="This Month"
        count="5"
        bgColor="bg-[#F8F8F8]"
        titleTextColor="text-[#929EAE]"
        countTextColor="text-[#1B212D]"
        bgIcon="bg-[#EBE8E8]"

      />
      <StatItem
        icon={<MoneyIncome />}
        title="Average Amount"
        count="$550.25"
        bgColor="bg-[#F8F8F8]"
        titleTextColor="text-[#929EAE]"
        countTextColor="text-[#1B212D]"
        bgIcon="bg-[#EBE8E8]"

      />
      <StatItem
        icon={<MoneyIncome />}
        title="Success Rate"
        count="98%"
        bgColor="bg-[#F8F8F8]"
        titleTextColor="text-[#929EAE]"
        countTextColor="text-[#0CAF60]"
        bgIcon="bg-[#EBE8E8]"

      />
    </div>



  );
};

export default OverviewStats;
